import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VContent,{staticClass:"blue-grey lighten-5"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }